import React from 'react';
import Container from '@mui/material/Container';
import Typography from '@mui/material/Typography';
import { usePartnerScope } from '../contexts/PartnerScopeContext';

/**
 * Empty state for data pages when no partner scope is resolved — internal
 * users see it until they pick a partner in the switcher (SOPHIA-35095).
 * Pages render this instead of ever querying with a partner id of 0.
 */
export function SelectPartnerPrompt(): React.ReactElement {
  const { isInternal } = usePartnerScope();

  return (
    <Container
      maxWidth="xl"
      sx={{ py: 10, textAlign: 'center' }}
      data-testid="select-partner-prompt"
    >
      <Typography variant="h5" sx={{ color: '#250e62', fontWeight: 600, mb: 1 }}>
        {isInternal ? 'Select a partner' : 'No partner assigned'}
      </Typography>
      <Typography variant="body1" color="text.secondary">
        {isInternal
          ? 'Choose a partner from the switcher in the header to view its data.'
          : 'Your account is not associated with a partner. Please contact your administrator.'}
      </Typography>
    </Container>
  );
}
